<template>
    <div class="grid grid-cols-3 gap-4">
        <UFormGroup v-for="field in fields" :key="field.key" :label="titleCase(field.label)"
            :error="nonNumeric.includes(field.key) ? 'Enter a number.' : invalid.includes(field.key) ? `Must be ${field.min} to ${field.max}.` : undefined">
            <UInput v-model="local[field.key]" type="text" inputmode="decimal" :disabled="disabled" @blur="commit()">
                <template #trailing>
                    <span class="text-xs text-gray-400">{{ field.unit }}</span>
                </template>
            </UInput>
        </UFormGroup>
    </div>
</template>

<script setup lang="ts">
import { VITAL_FIELDS, type VitalKey, type Vitals } from '~/types/fieldPost'
import { nonNumericVitals, sanitizeVitals, vitalErrors } from '~/utils/fieldPosts'

const props = defineProps<{
    modelValue: Vitals
    keys?: VitalKey[]
    disabled?: boolean
}>()

const emit = defineEmits<{ commit: [Vitals] }>()

const fields = computed(() => VITAL_FIELDS.filter(f => !props.keys || props.keys.includes(f.key)))
const local = reactive<Record<string, string>>({})
const invalid = ref<VitalKey[]>([])
const nonNumeric = ref<VitalKey[]>([])

function titleCase(label: string) {
    return label.replace(/\b[a-z]/g, c => c.toUpperCase())
}

watch(() => props.modelValue, (value) => {
    for (const field of VITAL_FIELDS) {
        local[field.key] = value?.[field.key] !== undefined ? String(value[field.key]) : ''
    }
}, { immediate: true })

function commit() {
    nonNumeric.value = nonNumericVitals(local)
    if (nonNumeric.value.length) return
    const vitals = sanitizeVitals(local)
    invalid.value = vitalErrors(vitals)
    if (invalid.value.length) return
    if (JSON.stringify(vitals) === JSON.stringify(sanitizeVitals(props.modelValue ?? {}))) return
    emit('commit', vitals)
}
</script>
